import { useCallback, useState } from "react";

import { downloadBlob } from "@/shared/utils/downloadBlob";

import { PayoutBatchesService } from "../services/payoutBatches.service";
import { type BatchError, classifyBatchError } from "../utils/batchErrors";

export interface UseTemplateDownloadResult {
  download: (country: string, rail: string) => Promise<void>;
  isDownloading: boolean;
  error: BatchError | null;
}

/** `GET /template?country&rail` → the browser's download tray. */
export function useTemplateDownload(): UseTemplateDownloadResult {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<BatchError | null>(null);

  const download = useCallback(async (country: string, rail: string) => {
    setIsDownloading(true);
    setError(null);
    try {
      const file = await PayoutBatchesService.downloadTemplate(country, rail);
      downloadBlob(file.blob, file.filename);
    } catch (err: unknown) {
      setError(classifyBatchError(err));
    } finally {
      setIsDownloading(false);
    }
  }, []);

  return { download, isDownloading, error };
}
